import { defineMessages } from 'react-intl';

export const TenantContextMessages = defineMessages({
  header: {
    id: 'administration.tab.tenantContext.header',
    defaultMessage: 'Tenant Context',
  },
  completeness: {
    id: 'administration.tab.tenantContext.completeness',
    defaultMessage: '{configured} / {total} sections configured',
  },
  saveTenantContext: {
    id: 'administration.tab.tenantContext.saveTenantContext',
    defaultMessage: 'Save Tenant Context',
  },
  saveSuccess: {
    id: 'administration.tab.tenantContext.saveSuccess',
    defaultMessage: 'Tenant Context saved successfully.',
  },
  saveError: {
    id: 'administration.tab.tenantContext.saveError',
    defaultMessage: 'Could not save Tenant Context. Please try again.',
  },

  section1: {
    id: 'administration.tab.tenantContext.section1',
    defaultMessage: 'Tenant Identity',
  },
  section2: {
    id: 'administration.tab.tenantContext.section2',
    defaultMessage: 'Geography & Operating Footprint',
  },
  section3: {
    id: 'administration.tab.tenantContext.section3',
    defaultMessage: 'Regulatory & Legal Environment',
  },
  section4: {
    id: 'administration.tab.tenantContext.section4',
    defaultMessage: 'Technology & Architecture Standards',
  },
  section5: {
    id: 'administration.tab.tenantContext.section5',
    defaultMessage: 'Organizational Structure & Ways of Working',
  },
  section6: {
    id: 'administration.tab.tenantContext.section6',
    defaultMessage: 'Security Posture & Access',
  },
  section7: {
    id: 'administration.tab.tenantContext.section7',
    defaultMessage: 'Non-Functional Defaults',
  },
  section8: {
    id: 'administration.tab.tenantContext.section8',
    defaultMessage: 'Resource Costs',
  },
  section9: {
    id: 'administration.tab.tenantContext.section9',
    defaultMessage: 'Risk Appetite & Change Culture',
  },
  section10: {
    id: 'administration.tab.tenantContext.section10',
    defaultMessage: 'Client Mandatory Deliverables',
  },

  // Section 1 field labels
  s1FieldName: { id: 'administration.tab.tenantContext.s1FieldName', defaultMessage: 'Name' },
  s1FieldIndustry: {
    id: 'administration.tab.tenantContext.s1FieldIndustry',
    defaultMessage: 'Industry / sector',
  },
  s1FieldSubIndustry: {
    id: 'administration.tab.tenantContext.s1FieldSubIndustry',
    defaultMessage: 'Sub-industry / business line',
  },
  s1FieldCompanySize: {
    id: 'administration.tab.tenantContext.s1FieldCompanySize',
    defaultMessage: 'Company size',
  },

  // Section 2 field labels
  s2FieldCountries: {
    id: 'administration.tab.tenantContext.s2FieldCountries',
    defaultMessage: 'Countries / regions of operation',
  },
  s2FieldPrimaryRegions: {
    id: 'administration.tab.tenantContext.s2FieldPrimaryRegions',
    defaultMessage: 'Primary regions',
  },
  s2FieldLanguages: {
    id: 'administration.tab.tenantContext.s2FieldLanguages',
    defaultMessage: 'Languages',
  },
  s2FieldTimeZones: {
    id: 'administration.tab.tenantContext.s2FieldTimeZones',
    defaultMessage: 'Time zones',
  },

  // Section 3 field labels
  s3FieldRegulations: {
    id: 'administration.tab.tenantContext.s3FieldRegulations',
    defaultMessage: 'Applicable regulations',
  },
  s3FieldDataSensitivity: {
    id: 'administration.tab.tenantContext.s3FieldDataSensitivity',
    defaultMessage: 'Data sensitivity',
  },
  s3FieldCompliancePosture: {
    id: 'administration.tab.tenantContext.s3FieldCompliancePosture',
    defaultMessage: 'Compliance posture',
  },

  // Section 4 field labels
  s4FieldHostingModel: {
    id: 'administration.tab.tenantContext.s4FieldHostingModel',
    defaultMessage: 'Hosting model',
  },
  s4FieldCloudProviders: {
    id: 'administration.tab.tenantContext.s4FieldCloudProviders',
    defaultMessage: 'Cloud providers',
  },
  s4FieldTechStack: {
    id: 'administration.tab.tenantContext.s4FieldTechStack',
    defaultMessage: 'Tech stack',
  },
  s4FieldIntegrationPatterns: {
    id: 'administration.tab.tenantContext.s4FieldIntegrationPatterns',
    defaultMessage: 'Integration patterns',
  },
  s4FieldDatabases: {
    id: 'administration.tab.tenantContext.s4FieldDatabases',
    defaultMessage: 'Databases',
  },
  s4FieldDevOpsTooling: {
    id: 'administration.tab.tenantContext.s4FieldDevOpsTooling',
    defaultMessage: 'DevOps tooling',
  },

  // Section 5 field labels
  s5FieldDeliveryModel: {
    id: 'administration.tab.tenantContext.s5FieldDeliveryModel',
    defaultMessage: 'Delivery model',
  },
  s5FieldMethodologies: {
    id: 'administration.tab.tenantContext.s5FieldMethodologies',
    defaultMessage: 'Methodologies',
  },
  s5FieldWaysOfWorking: {
    id: 'administration.tab.tenantContext.s5FieldWaysOfWorking',
    defaultMessage: 'Ways of working',
  },

  // Section 6 field labels
  s6FieldSecurityLevel: {
    id: 'administration.tab.tenantContext.s6FieldSecurityLevel',
    defaultMessage: 'Security level',
  },
  s6FieldIdentityStandards: {
    id: 'administration.tab.tenantContext.s6FieldIdentityStandards',
    defaultMessage: 'Identity standards',
  },
  s6FieldDataClassification: {
    id: 'administration.tab.tenantContext.s6FieldDataClassification',
    defaultMessage: 'Data classification',
  },
  s6FieldSecurityReview: {
    id: 'administration.tab.tenantContext.s6FieldSecurityReview',
    defaultMessage: 'Security review expectation',
  },

  // Section 7 field labels
  s7FieldAvailability: {
    id: 'administration.tab.tenantContext.s7FieldAvailability',
    defaultMessage: 'Availability target',
  },
  s7FieldPerformance: {
    id: 'administration.tab.tenantContext.s7FieldPerformance',
    defaultMessage: 'Performance expectations',
  },
  s7FieldSupportHours: {
    id: 'administration.tab.tenantContext.s7FieldSupportHours',
    defaultMessage: 'Support hours',
  },
  s7FieldEnvironments: {
    id: 'administration.tab.tenantContext.s7FieldEnvironments',
    defaultMessage: 'Environments',
  },
  s7FieldDocumentation: {
    id: 'administration.tab.tenantContext.s7FieldDocumentation',
    defaultMessage: 'Documentation expectations',
  },

  // Section 8 field labels
  s8FieldDayRates: {
    id: 'administration.tab.tenantContext.s8FieldDayRates',
    defaultMessage: 'Day rates per resource category',
  },

  // Section 9 field labels
  s9FieldRiskAppetite: {
    id: 'administration.tab.tenantContext.s9FieldRiskAppetite',
    defaultMessage: 'Risk appetite',
  },
  s9FieldChangeManagement: {
    id: 'administration.tab.tenantContext.s9FieldChangeManagement',
    defaultMessage: 'Change management rigor',
  },
  s9FieldOversightStyle: {
    id: 'administration.tab.tenantContext.s9FieldOversightStyle',
    defaultMessage: 'Project oversight style',
  },

  // Section 10 field labels
  s10FieldDeliverables: {
    id: 'administration.tab.tenantContext.s10FieldDeliverables',
    defaultMessage: 'Mandatory deliverables (list)',
  },
});
